import React, { useState, useEffect } from "react"
import { useFormikContext, FastField } from "formik"

import FormError from "../../../formError"

const OtherInfo = () => {
  const { values, errors, touched, handleChange } = useFormikContext()
  const [st, setSt] = useState([])
  const [countries, setCountries] = useState([])

  const getStates = () => {
    fetch(`${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/kyc/states`)
      .then((response) => response.json())
      .then((data) => setSt(data.data))
  }

  const getCountries = () => {
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/Countries`)
      .then((response) => response.json())
      .then((data) => {
        setCountries(data)
      })
  }

  useEffect(() => {
    getStates()
    getCountries()
  }, [])

  return (
    <>
      <div className="form-row">
        <div className="form-group col-md-12">
          <label htmlFor="business_address">
            Registered address of the business
          </label>
          <input
            type="text"
            className="form-control"
            id="business_address"
            name="business_address"
            onChange={handleChange}
            value={values.business_address}
          />

          <FormError
            touched={touched.business_address}
            message={errors.business_address}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group col-md-5">
          <label htmlFor="country">Country</label>
          <FastField
            className="form-control custom-select"
            as="select"
            id="country"
            name="country"
          >
            <option value="">Select Country</option>
            {countries.map((country) => (
              <option key={country.value} value={country.value}>
                {country.display}
              </option>
            ))}
          </FastField>

          <FormError touched={touched.country} message={errors.country} />
        </div>
      </div>

      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="state">State</label>
          <FastField
            className="form-control custom-select"
            as="select"
            id="state"
            name="state"
          >
            <option value="">Select State</option>
            {st.map((data) => (
              <option key={data.id} value={data.name}>
                {data.name}
              </option>
            ))}
          </FastField>

          <FormError touched={touched.state} message={errors.state} />
        </div>

        <div className="form-group col-md-5">
          <label htmlFor="city">City</label>
          <FastField
            type="text"
            className="form-control"
            id="city"
            name="city"
          />

          <FormError touched={touched.city} message={errors.city} />
        </div>
      </div>
    </>
  )
}

export default OtherInfo
